import React, { useState } from "react";
import styled from "styled-components";
import Footer from "./footer";


const FormContainer = styled.div`
  background: linear-gradient(#150b1f, #000);
  width: 100%;
  height: 100%;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(#150b1f, #000);
  border-radius: 5px;
  padding: 2rem;
`;

export const h2 = styled.h2`
    font-size: 1.3rem;
    color: white;
    font-weight: 500;
    margin-bottom: 30px;

`;

const Input = styled.input`
  width: 50%;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border: 1px solid lightgray;
  border-radius: 5px;
  font-size: 1rem;
`;

const Textarea = styled.textarea`
  width: 50%;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border: 1px solid lightgray;
  border-radius: 5px;
  font-size: 1rem;
`;

const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #ffffff;

  &:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  &:active {
    background-color: #6200ee;
    border-color: #3700b3;
  }

  &:focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  &.active {
    background-color: #0062cc;
    border-color: #005cbf;
  }
`;


const FORM_ENDPOINT = "https://public.herotofu.com/v1/703a8050-8c5e-11ed-a003-6f0b76086b1c";

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = () => {
    setTimeout(() => {
      setSubmitted(true);
    }, 100);
  };

  if (submitted) {
    return (
      <>
        <div className="text-2xl">Thank you!</div>
        <div className="text-md">We'll be in touch soon.</div>
      </>
    );
  }

  return (
    <>
    <FormContainer>
    <Form
      action={FORM_ENDPOINT}
      onSubmit={handleSubmit}
      method="POST"
      target="_blank"
    >
      <Input
        type="text"
        placeholder="Your name*"
        name="name"
        required
      />
      <Input
        type="email"
        placeholder="Email*"
        name="email"
        required
      />
      <Input
        type="text"
        placeholder="Budget"
        name="name"
        
      />
      <Textarea
        placeholder="Your message"
        name="message"
        required
      />
      <Button type="submit">Send</Button>
    </Form>
    </FormContainer>
    <Footer />
    </>
  );
};

export default ContactForm;